import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

//パラメータは以下参照
//https://swiperjs.com/swiper-api#parameters

export function sliderFooter(sliderFooterEl) {
  if ($(sliderFooterEl).length) {
    const swiperFooter = new Swiper(sliderFooterEl, {
      direction: "horizontal",
      loop: true,
      loopAddBlankSlides: true,
      autoHeight: false,
      centeredSlides: false,
      effect: "slide",
      modules: [Navigation, Pagination, Autoplay],
      centeredSlides: true,
      allowTouchMove: true,
      speed: 400,
      // centeredSlidesBounds: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 5000,
      },

      slidesPerView: 'auto',
      spaceBetween: 100,
    });


    $(".p-slider__ctrl--footer .swiper_pause").on("click", function(){
      if( $(this).hasClass('is-active') ) {
        swiperFooter.autoplay.start();
        $(this).removeClass("is-active");
      } else {
        swiperFooter.autoplay.stop();
        $(this).addClass("is-active");
      }
      return false;
    });
  }
}
